import {
  Row,
  Col,
  Card,
  Table,
  Button,
  Input,
  Modal,
  Form,
  Select,
  Checkbox,
  Tooltip,
  DatePicker,
  notification,
} from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import useDebounce from "../../hooks/useDebounce";
import ShowTotal from "../../components/ShowTotal";
import apiPath from "../../constants/apiPath";
import moment from "moment";
import lang from "../../helper/lang";
import ViewNotification from "./viewNotification";
const { TextArea } = Input;
const Search = Input.Search;

function Index() {
  const sectionName = lang("Notification");
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [singleNotification, setSingleNotification] = useState();
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [filters, setFilters] = useState({ type: "" });
  const [notificationModal, setNotificationModal] = useState(false);
  const [notification, setNotification] = useState();
  const [sendNotificationId, setSendNotificationId] = useState("");
  const [scheduleDateTime, setScheduleDateTime] = useState();
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [scheduleNotification, setScheduleNotification] = useState(false);
  const debouncedSearchText = useDebounce(searchText, 300);

  // Table Columns
  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (_, { title }) => (title ? title : "-"),
    },
    {
      title: `Type`,
      dataIndex: "type",
      key: "type",
    },
    {
      title: `Message`,
      dataIndex: "message",
      key: "message",
      className: "break-line",
    },
    {
      title: `Status`,
      dataIndex: "status",
      key: "status",
    },
    {
      title: `Sending On`,
      key: "createdAt",
      dataIndex: "createdAt",
      render: (_, { createdAt }) => {
        return moment(createdAt).format("DD-MMM-YYYY HH:mm");
      },
    },
    {
      title: `Action`,

      render: (_, record) => {
        return (
          <>
            <div className="main-new-jh-tool">
              <Tooltip
                title={"View Notification"}
                color={"purple"}
                key={"viewNotification"}
              >
                <Button
                  onClick={() => {
                    setNotification(record);
                    setNotificationModal(true);
                  }}
                >
                  <i className="fa fa-light fa-eye"></i>
                </Button>
              </Tooltip>
              <Tooltip
                title={
                  ["DRAFT", "DISABLED", "SENT"].includes(record.status)
                    ? `Now status is ${record.status} please make first ENABLED`
                    : "Send Now"
                }
                color={"purple"}
                key={"sendNow"}
              >
                <Button
                  disabled={
                    (loading === true && sendNotificationId === record._id) ||
                    ["DRAFT", "DISABLED", "SENT"].includes(record.status)
                  }
                  onClick={() => handleSent(record._id)}
                >
                  <i
                    className={`fa-solid ${loading === true && sendNotificationId === record._id
                        ? "fa fa-spinner fa-spin"
                        : "fa fa-solid fa-paper-plane"
                      }`}
                  ></i>
                </Button>
              </Tooltip>
              <Tooltip
                title={
                  ["DRAFT", "DISABLED", "SENT"].includes(record.status)
                    ? `Now status is ${record.status} please make first ENABLED`
                    : "Schedule Notification"
                }
                color={"purple"}
                key="scheduleNotification"
              >
                <Button
                  onClick={() => {
                    setNotification(record);
                    setScheduleNotification(true);
                  }}
                  disabled={["DRAFT", "DISABLED", "SENT"].includes(
                    record.status
                  )}
                >
                  <i className={`fa-solid ${"fa fa-solid fa-clock"}`}></i>
                </Button>
              </Tooltip>
              <Tooltip
                title="Edit Notification"
                color={"purple"}
                key="editNotification"
              >
                <Button
                  onClick={() => {
                    setNotification(record);
                    setEditMode(true);
                    setVisible(true);
                  }}
                >
                  <i className={`fa-solid ${"fa fa-solid fa-edit"}`}></i>
                </Button>
              </Tooltip>
              <Tooltip
                title={
                  record.status === "ENABLED"
                    ? "Disable Notification"
                    : "Enabled Notification "
                }
                color={"purple"}
                key="enableDisable"
              >
                <Button onClick={() => handleUpdateStatus(record._id)}>
                  <i className={`fa-solid ${"fa fa-solid fa-ban"}`}></i>
                </Button>
              </Tooltip>
            </div>
          </>
        );
      },
    },
  ];

  const handleFilterChange = (filterType, value) => {
    const newFilters = { ...filters, [filterType]: value };
    setFilters(newFilters);
    fetchData(pagination, newFilters);
  };

  const handleUpdateStatus = (id) => {
    request({
      url: `${apiPath.updateAdminNotificationStatus}/${id}`,
      method: "PUT",
      onSuccess: (data) => {
        ShowToast(data.message, Severty.SUCCESS);
        fetchData(pagination, filters);
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
      },
    });
  };

  // Fetch Data
  const fetchData = (pagination, filters) => {
    const params = new URLSearchParams();
    if (filters.type) {
      params.append("type", filters.type);
    }
    if (searchText) {
      params.append("search", searchText);
    }
    request({
      url: `${apiPath.listAdminNotification}?${params.toString()}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.data);
        setPagination((prev) => ({
          current: pagination.current,
          total: data.data.total,
          limit: data.data.limit,
        }));
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleSent = async (id) => {
    setSendNotificationId(id);
    setLoading(true);
    try {
      request({
        url: `${apiPath.sendNowNotification}/${id}`,
        method: "POST",
        onSuccess: (data) => {
          fetchData(pagination, filters);
          ShowToast(data.message, Severty.SUCCESS);
          setSendNotificationId("");
          setLoading(false);
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setSendNotificationId("");
          setLoading(false);
        },
      });
    } catch (error) {
      console.log("error in handle sent notification", error);
    }
  };

  const handleSchedule = async () => {
    try {
      request({
        url: `${apiPath.scheduleNotification}/${notification?._id}`,
        method: "PUT",
        data: { scheduledAt: scheduleDateTime },
        onSuccess: (data) => {
          fetchData(pagination, filters);
          ShowToast(data.message, Severty.SUCCESS);
          setScheduleNotification(false);
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setScheduleNotification(false);
        },
      });
    } catch (error) {
      console.log("Error occured while schedule notification", error);
    }
  };

  const handleChange = (pagination, filters) => {
    fetchData(pagination, filters);
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1 });
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination, filters);
  }, [refresh, debouncedSearchText]);
  return (
    <>
      <div className="tabled">
        <ViewNotification
          open={notificationModal}
          onClose={() => setNotificationModal(false)}
          notification={notification}
        />
        <Row gutter={[0, 0]}>
          <Col xs={24} xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={sectionName + ` ${lang("Manager")}`}
              extra={
                <>

                  <div className="main-new-filter-button">
                    <div className="tabled">
                      <Search
                        allowClear
                        size="large"
                        onChange={onSearch}
                        value={searchText}
                        onPressEnter={onSearch}
                        placeholder="Search by title, message"
                      />
                      <Select
                        placeholder="Filter by Type"
                        onChange={(value) => handleFilterChange("type", value)}
                        allowClear
                      >
                        <Select.Option value="Announcement">
                          Announcement
                        </Select.Option>
                        <Select.Option value="Alert">Alert</Select.Option>
                        <Select.Option value="Engagement">
                          Engagement
                        </Select.Option>
                        <Select.Option value="System Maintenance">
                          System Maintenance
                        </Select.Option>
                        <Select.Option value="Update">Update</Select.Option>
                        <Select.Option value="Other">Other</Select.Option>
                      </Select>
                      <Button
                        className="ant-btn-success"
                        title="Change Status"
                        onClick={() => setVisible(true)}
                      >
                        Add Notification
                      </Button>

                      {visible && (
                        <ApprovalStatus
                          show={true}
                          hide={() => {
                            setVisible(false);
                            setEditMode(false);
                            setNotification(null);
                          }}
                          refresh={() => setRefresh((prev) => !prev)}
                          editMode={editMode}
                          setEditMode={setEditMode}
                          editData={notification}
                        />
                      )}
                    </div>
                  </div>
                </>
              }
            >
              <h4 className="text-right mb-1">
                {" "}
                {pagination.total
                  ? ShowTotal(pagination.total)
                  : ShowTotal(0)}{" "}
              </h4>
              <div className="table-responsive customPagination">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={{
                    current: pagination.current,
                    defaultPageSize: 10,
                    responsive: true,
                    total: pagination.total,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    pageSizeOptions: ["10", "20", "30", "50"],
                  }}
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      {/* Schedule Notification Modal */}
      <Modal
        open={scheduleNotification}
        onCancel={() => setScheduleNotification(false)}
        title="Schedule Date & Time to send notification"
        footer={[
          <Button key="cancel" onClick={() => setScheduleNotification(false)}>
            Cancel
          </Button>,

          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => handleSchedule()}
          >
            Schedule
          </Button>,
        ]}
      >
        <DatePicker
          showTime
          allowClear
          onChange={(value, dateString) => setScheduleDateTime(dateString)}
        />
      </Modal>
    </>
  );
}

const ApprovalStatus = ({
  show,
  hide,
  refresh,
  editMode,
  setEditMode,
  editData,
}) => {
  const [forms] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [regions, setRegions] = useState([]);
  const [roles, setRoles] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const handleSelectAllChange = (e) => {
    setSelectAll(e.target.checked);
  };

  const getUser = (search) => {
    request({
      url: `${apiPath.getAllUserList}`,
      method: "GET",
      onSuccess: ({ data, status }) => {
        if (status) {
          setUser(data);
        }
      },
    });
  };

  // Add Notification
  const onCreate = (values) => {
    const status = forms.getFieldValue("status");
    const payload = {
      title: values.title,
      message: values.message,
      type: values.type,
      status: status,
      target: selectAll
        ? {
          type: "ALL",
          roles: [],
          regions: [],
        }
        : {
          type: "SEGMENT",
          roles: selectedRoles,
          regions: selectedRegions,
        },
    };
    console.log("payload--->", payload);
    setLoading(true);
    if (editMode) {
      request({
        url: `${apiPath.updateAdminNotification}/${editData._id}`,
        method: "PUT",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          setEditMode(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            refresh();
            hide();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(error.message, Severty.ERROR);
          setLoading(false);
          setEditMode(false);
        },
      });
    } else {
      request({
        url: `${apiPath.addAdminNotification}`,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            refresh();
            hide();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(error.message, Severty.ERROR);
          setLoading(false);
        },
      });
    }
  };

  const fetchedFilterUsers = () => {
    request({
      url: `${apiPath.filteredUsers}`,
      method: "GET",
      onSuccess: (res) => {
        setLoading(false);
        setFilteredUsers(res.data);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const formatRoles = (roles = []) => {
    return roles.map((role) => ({
      label: role.name,
      value: role._id,
    }));
  };

  const formatRegions = (regions = []) => {
    return regions.map((region) => ({
      label: region.city,
      value: region.city,
    }));
  };

  useEffect(() => {
    getUser();
    fetchedFilterUsers();
  }, []);

  useEffect(() => {
    if (filteredUsers) {
      setRegions(formatRegions(filteredUsers.regions));
      setRoles(formatRoles(filteredUsers.roles));
    }
  }, [filteredUsers]);

  useEffect(() => {
    if (editMode && editData) {
      forms.setFieldsValue({
        title: editData.title,
        type: editData.type,
        message: editData.message,
      });

      if (editData.target?.type === "ALL") {
        setSelectAll(true);
        setSelectedRegions([]);
        setSelectedRoles([]);
      } else {
        setSelectAll(false);
        setSelectedRegions(editData.target?.regions || []);
        setSelectedRoles(editData.target?.roles || []);
      }
    }
  }, [editMode, editData]);

  return (
    <>
      <Modal
        open={show}
        width={600}
        title={
          editMode === true
            ? "Update Notification To Target Audience"
            : "Add Notification To Target Audience"
        }
        onCancel={hide}
        footer={[
          <Button key="cancel" onClick={hide}>
            Cancel
          </Button>,

          <Button
            key="draft"
            type="default"
            loading={loading}
            onClick={() => {
              forms.setFieldsValue({ status: "DRAFT" });
              forms.submit();
            }}
          >
            Draft
          </Button>,

          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => forms.submit()}
          >
            {editMode === true ? "Update" : "Add"}
          </Button>,
        ]}
      >
        <Form id="create" form={forms} onFinish={onCreate} layout="vertical">
          <Row>
            <Col span={24} sm={24} md={24}>
              <Form.Item
                label="Title"
                name="title"
                rules={[
                  {
                    required: true,
                    message: "Please Enter Notification Title",
                  },
                  {
                    max: 80,
                    message:
                      "Title should not contain more then 80 characters!",
                  },
                  {
                    min: 2,
                    message: "Title should contain at least 2 characters!",
                  },
                ]}
                normalize={(value) => value.trimStart()}
              >
                <Input
                  autoComplete="off"
                  placeholder="Enter Notification Title"
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Select Notification Type"
                name="type"
                rules={[
                  { required: true, message: "Select Notification Type" },
                ]}
              >
                <Select placeholder="Select Status">
                  <option value=""> Select Status </option>
                  <option value={"Announcement"}> Announcement </option>
                  <option value={"Alert"}> Alert </option>
                  <option value={"Engagement"}> Engagement </option>
                  <option value={"System Maintenance"}>
                    System Maintenance{" "}
                  </option>
                  <option value={"Update"}> Update </option>
                  <option value={"Other"}> Other </option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={24} sm={24}>
              <Checkbox checked={selectAll} onChange={handleSelectAllChange}>
                All Users
              </Checkbox>
              <Form.Item label="Select Role">
                <Select
                  mode="multiple"
                  value={selectedRoles}
                  placeholder="Select Roles"
                  onChange={setSelectedRoles}
                  disabled={selectAll}
                  options={roles}
                />
              </Form.Item>
              <Form.Item label="Select Region">
                <Select
                  mode="multiple"
                  value={selectedRegions}
                  placeholder="Select Region"
                  onChange={(values) => setSelectedRegions(values)}
                  disabled={selectAll}
                  options={regions}
                />
              </Form.Item>
            </Col>
            <Col className="mt-1" span={24}>
              <Form.Item
                label="Message (Max : 500)"
                name="message"
                rules={[{ required: true, message: "Enter message" }]}
              >
                <TextArea
                  placeholder="Enter Message"
                  maxLength={250}
                  rows={5}
                  autoComplete="off"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default Index;
